<template>
	<div class="layout">
		<div class="tool-box">
			<div class="tool-box-title">
				<img src="/static/imgs/danju.png" class="jxyd-imgicon" />
				操作采购单
			</div>
			<button class="jxyd-button jxyd-primary" title="过账" @click="dataSubmitAndCheck"
				v-show="permission.isAudit && documentItem.checkState == 1">
				<Icon type="md-checkbox-outline" size='18' />
				过账
			</button>
			<button class="jxyd-button" title="回滚" @click="rollback([documentItem.id])"
				v-show="permission.isRollback && documentItem.id > 0 && documentItem.checkState > 1">
				<Icon type="md-sync" size='18' />
				回滚
			</button>
			<button class="jxyd-button" title="保存" @click="dataSubmit"
				v-show="permission.isEdit && documentItem.checkState == 1">
				<Icon type="md-bookmark" size='18' />
				保存
			</button>
			<button class="jxyd-button" title="打印" @click="printList" v-show="permission.isPrint">
				<Icon type="md-print" size='18' />
				打印
			</button>
		</div>
		<div>
			<div class="baseInfo">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/jibenxinxi.png" class="jxyd-imgicon" />
						基本信息
					</div>
					<div class="layout-title-right">
					</div>
				</div>
				<table class="baseinfo-table">
					<tr>
						<td class="key">
							单据编号
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input readonly="readonly" v-model="documentItem.code" type="text" placeholder="请输入单据编号"
								class="baseinfo-input" />
						</td>
						<td class="key">
							业务日期
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input v-model="documentItem.businessDate" type="date" placeholder="请选择业务日期"
								class="baseinfo-input" />
						</td>
					</tr>

					<tr>
						<td class="key">
							业务员
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td class="selectBox">
							<Select size="small" v-model="documentItem.userId" filterable clearable>
								<Option v-for="item in userList" placeholder="请选择业务员" :value="item.id" :key="item.id">
									{{item.userDisplayName}}
								</Option>
							</Select>
						</td>
						<td class="key">
							供应商
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td class="selectBox">
							<Select size="small" :disabled='documentItem.linkPlanListId>0'
								v-model="documentItem.supplierId" filterable clearable @on-change="getSupplierDiscount"
								style="width:70%;">
								<Option v-for="item in supplierList" placeholder="请选择供应商" :value="item.id"
									:key="item.id">
									{{item.name}}
								</Option>
							</Select>
							<label
								style="display:inline-block;text-align:center;width:29%;">{{'(折扣：'+documentItem.supplierDiscount+'%)'}}</label>
						</td>
					</tr>
					<tr>
						<td class="key">
							仓库
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td class="selectBox">
							<Select size="small" @on-change="depotChange" v-model="documentItem.depotId" filterable clearable>
								<Option v-for="item in depotList" :value="item.id" :key="item.id">
									{{ item.depotName }}
								</Option>
							</Select>
						</td>
						<td class="key">
							备注
						</td>
						<td style="text-align: left;">
							<input type="textarea" v-model="documentItem.note" placeholder="请输入备注"
								class="baseinfo-input">
						</td>
					</tr>
				</table>
			</div>
			<div class="commodityInfo">
				<div class="modal-title" style="padding-bottom:5px;">
					<div class="layout-title-left">
						<img src="/static/imgs/shangpin.png" class="jxyd-imgicon" />
						商品信息
					</div>
					<div class="layout-title-right">
						<!-- <SelectPurchasePlanModal @getResult="callPurchaseList"
							:selectPurchasePlanIds="[documentItem.linkPlanListId]"></SelectPurchasePlanModal> -->
						<SelectCommodityModal ref="selectCommodityModal"
							@getResult="data=>{this.commoditySelected = data;}" :selectedCommodity="commoditySelected"
							:type='"0"'></SelectCommodityModal>
						<SelectCommodityByCodeModal ref="selectCommodityByCodeModal"
							:commoditySelected="commoditySelected"
							@submitSelected='data=>{this.commoditySelected = data;}' @onInputVal='onInputVal'
							:type='"0"'>
						</SelectCommodityByCodeModal>
					</div>
				</div>
				<div style="padding:0px 10px;font-size:15px;color:red;">
					<!-- 关联订单：<a class="jxyd-a"
						@click="toPlanList(documentItem.linkPlanListId)">{{documentItem.linkPlanListCode}}</a> -->
				</div>
				<Table stripe :columns="commodityColumn" :data="documentItem.purchaseDetailList"></Table>
			</div>
			<div id="extraCostInfo">
				<ExtraCostData :selectedExtraCost.sync='documentItem.extraCostInfos'></ExtraCostData>
			</div>
			<div class="logisticsInfo">
				<LogisticsInfo :selectedLogistics.sync='documentItem.logisticsInfos'></LogisticsInfo>
			</div>
			<div class="file">
				<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
					<div class="layout-title-left">
						<Icon type="ios-link" size='20' color='#bd10e0' />
						单据附件
					</div>
					<div class="layout-title-right">
					</div>
				</div>
				<div style="padding:15px 10px;">
					<DocumentFile :isShow='false' :fileList.sync='documentItem.fileList'
						:actionPath='"/file/file/UploadFile"'></DocumentFile>
				</div>
			</div>
			<div id="voucher-bottomBar">
				<table style="float: left;">
					<tr>
						<td style="border-right:1px solid #DCDFE6;padding-right:15px;">
							<span style="font-size: 16px;font-weight: bold;color: var(--font1Color);">合计：</span>
							<span style="color: #ff4d4d;font-size: 22px;">￥{{documentItem.originalPrice}}</span>
						</td>
						<td style="border-right:1px solid #DCDFE6;padding-right:15px;">
							<span style="font-size: 16px;font-weight: bold;color: var(--font1Color);">折后金额：</span>
							<span style="color: #ff4d4d;font-size: 22px;">￥{{documentItem.amount}}</span>
						</td>
						<td style="font-size: 16px;font-weight: bold;color: var(--font1Color);padding-left:15px;">支付方式：
						</td>
						<td>
							<SelectTradeMethod :value.sync='documentItem.payWay' :accountPid='accountPid'>
							</SelectTradeMethod>
						</td>
						<td style="padding-left: 5px;">
							<InputNumber v-model="documentItem.payAmount" :min="0" placeholder="付款金额"
								@on-change="!documentItem.payAmount ? documentItem.payAmount = 0 : documentItem.payAmount = documentItem.payAmount">
							</InputNumber>
						</td>
					</tr>
				</table>
			</div>
			<div class="billStateCls" v-show="documentItem.checkState == 2"><span>已过账</span></div>
			<div class="billStateCls" v-show="documentItem.checkState == 3"><span>已完结</span></div>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatNum from '@/utils/formatNum'
	import SelectCommodityModal from '@/components/SelectCommodityModal'
	import formatDate from '@/utils/formatDate'
	import dateUtil from '@/utils/dateUtil'
	import SelectTradeMethod from '@/components/SelectTradeMethod'
	import DocumentFile from '@/components/DocumentFile'
	import SelectPurchasePlanModal from '@/components/SelectPurchasePlanModal'
	import LogisticsInfo from '@/components/LogisticsInfo'
	import ExtraCostData from '@/components/ExtraCostData'
	import SelectCommodityByCodeModal from '@/components/SelectCommodityByCodeModal'
	export default {
		name: 'purchaselistfunc',
		components: {
			SelectCommodityModal,
			SelectTradeMethod,
			DocumentFile,
			SelectPurchasePlanModal,
			LogisticsInfo,
			ExtraCostData,
			SelectCommodityByCodeModal
		},
		data() {
			return {
				documentItem: {
					id: 0,
					code: '',
					businessDate: '',
					originalPrice: 0,
					depotId:0,
					amount: 0,
					payAmount: 0,
					purchaseDetailList: [],
					extraCostInfos: [],
					logisticsInfos: [],
					linkPlanListId: 0,
					linkPlanListCode: '',
					linkPlanListDeposit: 0, //订单定金
					supplierId: '',
					supplierName: '',
					supplierDiscount: '0',
					userId: '',
					userName: '',
					creator: parseInt(localStorage.getItem("userId")),
					note: '',
					payWay: '',
					checkState: 1, //未审核
					fileList: []
				},
				commodityColumn: [{
						title: '操作',
						key: 'action',
						width: 80,
						align: 'center',
						fixed: 'left',
						render: (h, params) => {
							return [h('Icon', {
								style: {
									cursor: 'pointer'
								},
								props: {
									type: 'md-trash',
									size: 24
								},
								on: {
									click: (e) => {
										this.documentItem.purchaseDetailList.splice(params.index,
											1);
									}
								}
							})]
						}
					},
					{
						title: '商品',
						key: 'name',
						fixed: 'left',
						width: 280,
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.$router.push({
											path: 'commoditydetailinfo',
											query: {
												commodityId: params.row.commodity.id
											}
										});
									}
								}
							}, params.row.name);
						}
					},
					{
						title: '单位',
						key: 'unit',
						width: 100,
						render: (h, params) => {
							return [h('Select', {
									props: {
										transfer: true,
										value: params.row.unit
									},
									on: {
										input: (event) => {
											this.documentItem.purchaseDetailList[params.index].unit =
												event;
											this.unitChange(params.index);
										}
									},
								},
								params.row.commodity.extraUnits.map(function(type) {
									if (type != null) {
										return h('Option', {
											props: {
												value: type.unit,
												key: type.unit
											}
										}, type.unit);
									}
								})
							)];
						}
					},
					{
						title: '规格',
						key: 'format',
						width: 180,
					},
					{
						title: '仓库',
						key: 'depotId',
						width: 130,
						render: (h, params) => {
							return [h('Select', {
									props: {
										transfer: true,
										value: params.row.depotId
									},
									style: {
										width: '100%'
									},
									on: {
										input: (event) => {
											this.documentItem.purchaseDetailList[params.index]
												.depotId = event;
										}
									},
								},
								this.depotList.map(function(depot) {
									return h('Option', {
										props: {
											value: depot.id,
											key: depot.depotName
										}
									}, depot.depotName);
								})
							)];
						}
					},
					{
						title: '保质期',
						key: 'sellbyDate',
						width: 200,
						render: (h, params) => {
							return h('DatePicker', {
								attrs: {
									transfer: true,
									type: 'daterange',
									value: params.row.sellByDate,
									placeholder :'请选择',
									disabled : !this.documentItem.purchaseDetailList[params.index].commodity.enableBatch
								},
								on: {
									'on-change': (e) => {
										this.documentItem.purchaseDetailList[params.index].sellByDate = e;
									}
								}
							})
						}
					},
					{
						title: '当前库存',
						key: 'stock',
						width: 140,
						render: (h, params) => {
							return h('span', {}, this.getCurrentIStock(params.index))
						}
					},
					{
						title: '数量',
						key: 'quantity',
						width: 130,
						render: (h, params) => {
							return [h('InputNumber', {
								attrs: {
									'min': 0,
									'value': params.row.quantity
								},
								on: {
									input: (e) => {
										this.documentItem.purchaseDetailList[params.index]
											.quantity = e;
										this.$nextTick(function() {
											if (e == null) {
												this.documentItem.purchaseDetailList[params
													.index].quantity = 0;
											}
											this.$set(this.documentItem.purchaseDetailList[
													params.index],
												`priceAfterDiscount`, formatNum(this
													.documentItem.purchaseDetailList[
														params.index].price * (this
														.documentItem
														.purchaseDetailList[params
															.index].discount / 100)));
											this.$set(this.documentItem.purchaseDetailList[
												params.index], `amount`, formatNum(
												this.documentItem
												.purchaseDetailList[params.index]
												.quantity * this.documentItem
												.purchaseDetailList[params.index]
												.priceAfterDiscount));
										});
									}
								}
							})]
						}
					},
					{
						title: '单价',
						key: 'price',
						width: 140,
						render: (h, params) => {
							return [h('InputNumber', {
								attrs: {
									'min': 0,
									'value': params.row.price
								},
								on: {
									input: (e) => {
										this.documentItem.purchaseDetailList[params.index].price =
											e;
										this.$nextTick(function() {
											if (e == null) {
												this.documentItem.purchaseDetailList[params
													.index].price = 0;
											} else if (e < 0) {
												this.documentItem.purchaseDetailList[params
													.index].price = 0;
											}
											this.$set(this.documentItem.purchaseDetailList[
													params.index],
												`priceAfterDiscount`, formatNum(this
													.documentItem.purchaseDetailList[
														params.index].price * (this
														.documentItem
														.purchaseDetailList[params
															.index].discount / 100)));
											this.$set(this.documentItem.purchaseDetailList[
												params.index], `amount`, formatNum(
												this.documentItem
												.purchaseDetailList[params.index]
												.quantity * this.documentItem
												.purchaseDetailList[params.index]
												.priceAfterDiscount));
										});
									}
								}
							})]
						}
					},
					{
						title: '折扣(%)',
						key: 'discount',
						width: 140,
						render: (h, params) => {
							return [h('InputNumber', {
								attrs: {
									'min': 0,
									'max': 100,
									'value': params.row.discount
								},
								on: {
									input: (e) => {
										this.documentItem.purchaseDetailList[params.index]
											.discount = e;
										this.$nextTick(function() {
											if (e == null) {
												this.documentItem.purchaseDetailList[params
													.index].discount = 100;
											} else if (e < 0) {
												this.documentItem.purchaseDetailList[params
													.index].discount = 100;
											}
											this.$set(this.documentItem.purchaseDetailList[
													params.index],
												`priceAfterDiscount`, formatNum(this
													.documentItem.purchaseDetailList[
														params.index].price * (this
														.documentItem
														.purchaseDetailList[params
															.index].discount / 100)));
											this.$set(this.documentItem.purchaseDetailList[
												params.index], `amount`, formatNum(
												this.documentItem
												.purchaseDetailList[params.index]
												.quantity * this.documentItem
												.purchaseDetailList[params.index]
												.priceAfterDiscount));

										});
									}
								}
							})]
						}
					},
					{
						title: '折后单价',
						key: 'priceAfterDiscount',
						width: 140
					},
					{
						title: '总金额',
						key: 'amount',
						width: 200
					},
					{
						title: '备注',
						key: 'note',
						width: 350,
					}
				],
				userList: [],
				supplierList: [],
				permission: {
					isAdd: false,
					isEdit: false,
					isDelete: false,
					isAudit: false,
					isBatchAudit: false,
					isPrint: false,
					isRollback: false,
					isExport: false,
					isBatchPrint: false
				},
				accountPid: 'sfkzh',
				depotList: []
			}
		},
		computed: {
			commoditySelected: {
				get() {
					let data = [];
					this.documentItem.purchaseDetailList.forEach(item => {
						let formatItems = item.format.split(',');
						let priceTypeData = {};
						let imgFiles = null;
						if (formatItems.length > 1) {
							let priceTypeGroup = item.commodity.commodityPriceTypeGroups.find(m => m
								.groupName == formatItems[0]);
							if (priceTypeGroup) {
								imgFiles = priceTypeGroup.imgFiles;
							}
							priceTypeData = priceTypeGroup.commodityPriceTypes.find(m => m.priceType ==
								formatItems[1]);
						}
						let existData = data.find(m => m.commodity.id == item.commodity.id);
						let isExist = true;
						if (existData) {
							for (let i = 0; i < existData.data.length; i++) {
								if (existData.data[i].unit != item.unit) {
									isExist = false;
									break;
								}
								if (existData.data[i].priceType == item.format) {
									isExist = false;
									break;
								}
							}
						}
						if (existData && isExist) {
							existData.data.push({
								priceType: item.format,
								quantity: item.quantity,
								imgFiles: imgFiles,
								sellByDate: item.sellByDate,
								unit: item.unit,
								price: item.price,
								discount: item.discount,
								intoPrice: priceTypeData ? priceTypeData.intoPrice : 0,
								retailPrice: priceTypeData ? priceTypeData.retailPrice : 0,
								wholesalePricePrice: priceTypeData ? priceTypeData
									.wholesalePricePrice : 0
							});
						} else {

							let dataItem = {};
							dataItem.commodity = item.commodity;

							dataItem.data = [];
							dataItem.data.push({
								priceType: item.format,
								quantity: item.quantity,
								imgFiles: imgFiles,
								sellByDate: item.sellByDate,
								unit: item.unit,
								price: item.price,
								discount: item.discount,
								intoPrice: priceTypeData ? priceTypeData.intoPrice : 0,
								retailPrice: priceTypeData ? priceTypeData.retailPrice : 0,
								wholesalePricePrice: priceTypeData ? priceTypeData
									.wholesalePricePrice : 0
							});
							data.push(dataItem);
						}
					});
					return data;

				},
				set(newValue) {
					//这的data就是B页面传递过来的数据
					this.documentItem.purchaseDetailList = []
					newValue.forEach(item => {
						item.data.forEach(item2 => {
							let detail = {
								commodityId: item.commodity.id,
								name: item.commodity.name,
								unit: item2.unit,
								format: item2.priceType,
								quantity: item2.quantity,
								depotId: this.documentItem.depotId ? this.documentItem
									.depotId : 0,
								depotName: this.documentItem.depotName ? this
									.documentItem.depotName : '',
								price: 0,
								sellByDate: item2.sellByDate,
								discount: item2.discount ? item2.discount : 100,
								priceAfterDiscount: 0,
								amount: 0,
								note: '',
								creator: parseInt(localStorage.getItem("userId")),
								commodity: item.commodity,
								commodityId: item.commodity.id
							};
							detail.price = item2.price ? item2.price : this.getCommodityTypePrice(
								detail);
							detail.priceAfterDiscount = formatNum(detail.price * (detail.discount /
								100));
							detail.amount = formatNum(detail.quantity * detail
								.priceAfterDiscount)
							this.documentItem.purchaseDetailList.push(detail);
						});
					});
				}
			}
		},
		methods: {
			emptyForm() {
				this.documentItem.id = 0;
				this.documentItem.businessDate = formatDate(dateUtil.getCurrentDate(), 'yyyy-MM-dd');
				this.documentItem.amount = 0;
				this.documentItem.depotId = 0;
				this.documentItem.originalPrice = 0;
				this.documentItem.purchaseDetailList = [];
				this.documentItem.linkPlanListId = 0;
				this.documentItem.linkPlanListCode = '';
				this.documentItem.linkPlanListDeposit = 0;
				this.documentItem.supplierId = '';
				this.documentItem.supplierName = '';
				this.documentItem.supplierDiscount = '0';
				this.documentItem.userId = parseInt(localStorage.getItem("userId"));
				this.documentItem.payWay = '';
				this.documentItem.userName = '';
				this.documentItem.creator = parseInt(localStorage.getItem("userId"));
				this.documentItem.note = '';
				this.documentItem.checkState = 1;
				this.documentItem.payAmount = 0;
				this.documentItem.extraCostInfos = [];
				this.documentItem.logisticsInfos = [{
					companyName: '',
					code: '',
					receiver: '',
					freight: 0,
					note: '',
					creator: parseInt(localStorage.getItem("userId")),
				}];
				this.extraAdvancePay = 0;
				this.dfAdvancePay = 0;
				this.documentItem.fileList = [];
				this.getNextCode();
			},
			unitChange(index) {
				this.documentItem.purchaseDetailList[index].price = this.getCommodityTypePrice(this
					.documentItem.purchaseDetailList[index]);

				this.documentItem.purchaseDetailList[index]
					.priceAfterDiscount =
					formatNum(this.documentItem.purchaseDetailList[index]
						.price *
						(this
							.documentItem.purchaseDetailList[index].discount /
							100))

				this.documentItem.purchaseDetailList[index].amount = formatNum(
					this.documentItem.purchaseDetailList[index].quantity *
					this
					.documentItem.purchaseDetailList[index]
					.priceAfterDiscount);
			},
			getCurrentIStock(index) {
				let commodityInventorys = this.documentItem.purchaseDetailList[index].commodity
					.commodityInventorys;
				if (!commodityInventorys) {
					return 0;
				}
				let stock = 0;
				for (let i = 0; i < commodityInventorys.length; i++) {
					if (commodityInventorys[i].commodityPriceType == this.documentItem.purchaseDetailList[index].format) {
						stock += commodityInventorys[i].stock;
					}
				}
				let extraUnits = this.documentItem.purchaseDetailList[index].commodity.extraUnits;
				if (extraUnits) {
					extraUnits.forEach(item => {
						if (item.unit == this.documentItem.purchaseDetailList[index].unit) {
							stock = item.conversionRate * stock;
						}
					});
				}
				if (stock && Number.isFinite(stock)) {
					return formatNum(stock);
				} else {
					return 0;
				}
			},
			getCommodityTypePrice(data) {
				const currentUnit = data.commodity.extraUnits.find(m => m.unit == data.unit);
				// 解析价格类型
				const priceTypeItems = data.format.split(',');
				let currentPriceType = null;

				if (priceTypeItems.length === 2) {
					currentPriceType = this.findPriceType(data.commodity, priceTypeItems);
				}
				if (currentUnit && currentPriceType) {
					let price = currentPriceType.intoPrice;
					return formatNum(price / currentUnit.conversionRate);
				}
				return 0;
			},
			// 提取价格类型查找逻辑
			findPriceType(commodity, priceTypeItems) {
				const [groupName, priceTypeName] = priceTypeItems;

				const targetGroup = commodity.commodityPriceTypeGroups.find(
					group => group.groupName === groupName
				);

				if (!targetGroup) return null;

				return targetGroup.commodityPriceTypes.find(
					priceType => priceType.priceType === priceTypeName
				) || null;
			},
			submitValidate() {
				if (!this.documentItem.code) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "编号不可为空"
					});
					return false;
				}

				if (!this.documentItem.businessDate) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择业务日期"
					});
					return false;
				} else {
					//this.documentItem.businessDate = new Date(this.documentItem.businessDate);
				}

				if (!this.documentItem.userId) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择业务员"
					});
					return false;
				}

				if (!this.documentItem.supplierId) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择供应商"
					});
					return false;
				}
				if (this.documentItem.amount <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "您还没有选择商品"
					});
					return false;
				}

				if (this.documentItem.payAmount > this.documentItem.amount) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "付款金额不得大于总金额"
					});
					return false;
				}
				
				let detailArray = this.documentItem.purchaseDetailList.filter(m => m.sellByDate.length < 2 && m
					.commodity.enableBatch == true);
				if (detailArray.length > 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "有商品未设置保质期"
					});
					return false
				}
				return true;
			},
			dataSubmit() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				request.post('/api/PurchaseList/EditPurchaseList', self.documentItem).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}

					//记录采购单操作
					var log = {
						FlowId: response.data,
						Title: '采购单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此采购单' : '创建了此采购单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})
					if (self.documentItem.linkPlanListId > 0) {
						//记录采购订单操作
						log = {
							FlowId: self.documentItem.linkPlanListId,
							Title: '采购订单日志',
							OperationContent: '“' + self.documentItem.code + '”引用了此采购订单',
							Operator: parseInt(localStorage.getItem("userId")),
							State: 1,
							Creator: parseInt(localStorage.getItem("userId"))
						}
						request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
							if (response.data.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: '日志记录失败:' + response.data.errorMsg
								});
								return;
							}
						}).catch(function(error) {})
					}
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '保存成功!'
					});
					self.emptyForm();
				}).catch(function(error) {})
			},
			dataSubmitAndCheck() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				request.post('/api/PurchaseList/EditPurchaseList', self.documentItem).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}

					//记录采购单操作
					var log = {
						FlowId: response.data,
						Title: '采购单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此采购单' : '创建了此采购单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})
					if (self.documentItem.linkPlanListId > 0) {
						//记录采购订单操作
						log = {
							FlowId: self.documentItem.linkPlanListId,
							Title: '采购订单日志',
							OperationContent: '“' + self.documentItem.code + '”引用了此采购订单',
							Operator: parseInt(localStorage.getItem("userId")),
							State: 1,
							Creator: parseInt(localStorage.getItem("userId"))
						}
						request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
							if (response.data.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: '日志记录失败:' + response.data.errorMsg
								});
								return;
							}
						}).catch(function(error) {})
					}
					self.documentItem.id = response.data;
					self.checkPurchaseList([self.documentItem], '采购单过账后不可更改，内容不可编辑，是否继续操作？');
				}).catch(function(error) {})
			},
			getNextCode() {
				let self = this;
				request.get('/api/PurchaseList/GetNextCode', {
					params: {
						prefix: 'CGD'
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}

					self.documentItem.code = response.data;
				}).catch(function(error) {})
			},
			checkPurchaseList(objs, func) {
				var self = this;
				if (objs.length <= 0) {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "没有选中记录！"
					});
					return;
				}
				let stateObj = [];
				let purchaseIds = [];
				for (var i = 0; i < objs.length; i++) {
					if (objs[i].checkState != 1) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "选中记录中包含不可过账的数据！"
						});
						return;
					}
					if (objs[i].payAmount < objs[i].amount) {
						stateObj.push({
							id: objs[i].id,
							state: 2
						});
					} else {
						stateObj.push({
							id: objs[i].id,
							state: 3
						});
					}
					purchaseIds.push(objs[i].id);
				}
				this.$Modal.confirm({
					title: "操作警告",
					content: func,
					onOk() {
						request.post('/api/PurchaseList/CheckPurchaseList', stateObj).then(function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: response.errorMsg
								});
								return;
							}
							var log = [];
							for (var i = 0; i < purchaseIds.length; i++) {
								//记录采购单操作
								log.push({
									FlowId: purchaseIds[i],
									Title: '采购单日志',
									OperationContent: '过账了此采购单',
									Operator: parseInt(localStorage.getItem("userId")),
									State: 1,
									Creator: parseInt(localStorage.getItem("userId"))
								});
							}
							request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '过账成功!'
							});
							self.emptyForm();
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			rollback(ids) {
				if (ids.length < 1) {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "没有选中记录！"
					});
					return;
				}
				let self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: '是否回滚到审核流程？',
					onOk() {
						request.post('/api/PurchaseList/Rollback', ids).then(function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: "采购订单回滚失败：" + response.errorMsg
								});
								return;
							}

							var log = [];
							for (var i = 0; i < ids.length; i++) {
								//记录采购单操作
								log.push({
									FlowId: ids[i],
									Title: '采购订单日志',
									OperationContent: '回滚了此采购订单',
									Operator: parseInt(localStorage.getItem("userId")),
									State: 1,
									Creator: parseInt(localStorage.getItem("userId"))
								});
							}
							request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '回滚成功!'
							});
							self.getPurchaseList(ids[0]);
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			getSupplierDiscount(val) {
				for (var i = 0; i < this.supplierList.length; i++) {
					if (this.supplierList[i].id == val) {
						this.documentItem.supplierDiscount = this.supplierList[i].discount;
					}
				}
				this.countAmount();
			},
			countAmount() { //计算总金额
				this.documentItem.amount = 0;
				this.documentItem.originalPrice = 0;
				for (let i = 0; i < this.documentItem.purchaseDetailList.length; i++) {
					this.documentItem.originalPrice += this.getCommodityTypePrice(this.documentItem
						.purchaseDetailList[i]) * this.documentItem.purchaseDetailList[i].quantity;
					this.documentItem.amount += this.documentItem.purchaseDetailList[i].amount;
				}
				let totalFreight = 0;
				for (let i = 0; i < this.documentItem.logisticsInfos.length; i++) {
					totalFreight += formatNum(this.documentItem.logisticsInfos[i].freight);
				}
				this.documentItem.originalPrice = formatNum(this.documentItem.originalPrice - this
					.extraAdvancePay + this.dfAdvancePay +
					totalFreight)
				this.documentItem.amount = formatNum(((this.documentItem.amount * (this.documentItem
							.supplierDiscount / 100)) - this
						.extraAdvancePay + this.dfAdvancePay) - this.documentItem.linkPlanListDeposit +
					totalFreight)
			},
			initUserToSelect() { //初始化用户下拉框数据源
				let self = this;
				request.get('/api/User/GetUserToSelect').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}
					self.userList = response.data;
				}).catch(function(error) {})
			},
			initSupplierSelect() {
				let self = this;
				request.get('/api/Supplier/GetSupplierToSelect').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取供应商数据失败：" + response.errorMsg
						});
						return;
					}
					self.supplierList = response.data;
				}).catch(function(error) {})
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['PurchaseList.Add', 'PurchaseList.Edit', 'PurchaseList.Delete',
						'PurchaseList.Audit', 'PurchaseList.BatchAudit', 'PurchaseList.Print',
						'PurchaseList.Rollback', 'PurchaseList.Export', 'PurchaseList.BatchPrint'
					],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if (tipTimeoutCount != undefined) {
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					} else if (response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)) {
						self.$Modal.warning({
							title: '系统到期提示',
							content: response.errorMsg,
							onOk: () => {
								localStorage.setItem("_tipTimeoutCount", 1);
							}
						});
					}
					if (tipTimeoutCount == undefined || tipTimeoutCount < 1000) {
						localStorage.setItem("_tipTimeoutCount", tipTimeoutCount == undefined ? 1 :
							tipTimeoutCount + 1)
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'PurchaseList.Add':
								self.permission.isAdd = response.data[i].permission
								break;
							case 'PurchaseList.Edit':
								self.permission.isEdit = response.data[i].permission
								break;
							case 'PurchaseList.Delete':
								self.permission.isDelete = response.data[i].permission
								break;
							case 'PurchaseList.Audit':
								self.permission.isAudit = response.data[i].permission
								break;
							case 'PurchaseList.BatchAudit':
								self.permission.isBatchAudit = response.data[i].permission
								break;
							case 'PurchaseList.Print':
								self.permission.isPrint = response.data[i].permission
								break;
							case 'PurchaseList.Rollback':
								self.permission.isRollback = response.data[i].permission
								break;
							case 'PurchaseList.Export':
								self.permission.isExport = response.data[i].permission
								break;
							case 'PurchaseList.BatchPrint':
								self.permission.isBatchPrint = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			},
			printList() {
				this.packPrintData([this.documentItem]);
			},
			getPurchaseList(purchaseId) {
				let self = this;
				request.get('/api/PurchaseList/GetPurchaseList', {
					params: {
						id: purchaseId
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.initPurchaseList(response.data);
				}).catch(function(error) {})
			},
			initPurchaseList(data) {
				this.documentItem = data;
			},
			callPurchaseList(data) {
				if (!data && data.length <= 0) {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "未选择数据"
					});
					return;
				}
				this.documentItem.purchaseDetailList = [];
				if (data[0] != null) {
					this.documentItem.linkPlanListId = data[0].id;
					this.documentItem.linkPlanListCode = data[0].code;
					this.documentItem.supplierId = data[0].supplierId;
					this.documentItem.supplierName = data[0].supplierName;
					this.documentItem.supplierDiscount = data[0].supplierDiscount;
					this.documentItem.linkPlanListDeposit = data[0].deposit;

					for (let i = 0; i < data[0].purchasePlanDetailList.length; i++) {
						//插入商品集合
						this.documentItem.purchaseDetailList.push({
							commodityId: data[0].purchasePlanDetailList[i].commodityId,
							name: data[0].purchasePlanDetailList[i].name,
							unit: data[0].purchasePlanDetailList[i].unit,
							format: data[0].purchasePlanDetailList[i].format,
							stock: data[0].purchasePlanDetailList[i].stock,
							quantity: data[0].purchasePlanDetailList[i].quantity,
							price: data[0].purchasePlanDetailList[i].price,
							discount: data[0].purchasePlanDetailList[i].discount,
							priceAfterDiscount: data[0].purchasePlanDetailList[i].priceAfterDiscount,
							amount: data[0].purchasePlanDetailList[i].amount,
							note: data[0].purchasePlanDetailList[i].note,
							creator: parseInt(localStorage.getItem("userId")),
							commodity: data[0].purchasePlanDetailList[i].commodity
						});
					}
				} else {
					this.documentItem.linkPlanListId = 0;
					this.documentItem.linkPlanListCode = '';
					this.documentItem.supplierId = '';
					this.documentItem.supplierName = '';
					this.documentItem.supplierDiscount = '0';
					this.documentItem.linkPlanListDeposit = 0;
				}
			},
			toPlanList(linkPlanListId) {
				this.$router.push({
					path: 'purchaseplanlistdetail',
					query: {
						planListId: linkPlanListId
					}
				});
			},
			packPrintData(data) {
				data.forEach((item, index) => {
					switch (item.checkState) {
						case 1:
							item.checkState = '已创建'
							break;
						case 2:
							item.checkState = '已过账'
							break;
						case 3:
							item.checkState = '已完结'
							break;
					}
					item.businessDate = item.businessDate.replace(' 00:00:00', '');
					item.extraCostInfos.forEach(item2=>{
						item2.createdate = item2.createdate.replace(' 00:00:00', '');
					})
				})
				let selectedReceiptData = {
					name: 'purchaseList',
					title: '采购单',
					attributes: ['baseFieldItem', 'purchaseDetailList', 'extraCostInfos',
						'logisticsInfos', 'footInfos'
					],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'supplierName',
							displayName: '供应商'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					purchaseDetailList: [{
							name: 'name',
							displayName: '名称'
						},
						{
							name: 'price',
							displayName: '单价'
						},
						{
							name: 'quantity',
							displayName: '数量'
						},
						{
							name: 'format',
							displayName: '规格'
						},
						{
							name: 'discount',
							displayName: '折扣(%)'
						},
						{
							name: 'amount',
							displayName: '金额'
						},
						{
							name: 'unit',
							displayName: '计量单位'
						}
					],
					extraCostInfos: [{
							name: 'type',
							displayName: '费用类型'
						},
						{
							name: 'advancePayWay',
							displayName: '垫付方式'
						},
						{
							name: 'payAccount',
							displayName: '结算账户'
						},
						{
							name: 'amount',
							displayName: '金额'
						},
						{
							name: 'createdate',
							displayName: '创建时间'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					logisticsInfos: [{
							name: 'companyName',
							displayName: '物流公司'
						},
						{
							name: 'code',
							displayName: '物流单号'
						},
						{
							name: 'receiver',
							displayName: '收货人'
						},
						{
							name: 'freight',
							displayName: '运费'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'createDate',
							displayName: '创建时间'
						}
					],
					footInfos: [{
							name: 'supplierDiscount',
							displayName: '折扣(%)'
						},
						{
							name: 'originalPrice',
							displayName: '本单应收'
						},
						{
							name: 'amount',
							displayName: '折后金额'
						},
						{
							name: 'payAmount',
							displayName: '本次实收'
						},
						{
							name: 'payWay',
							displayName: '支付方式'
						},
					]
				}
				localStorage.setItem('_printData', JSON.stringify(selectedReceiptData));
				this.$router.push({
					path: 'printerpage'
				});
			},
			onInputVal(val) {
				this.$refs.selectCommodityModal.searchItems.name = val;
				this.$refs.selectCommodityModal.openSelectCommodityModal();
			},
			initPurchasePlanList(id) {
				let self = this
				request.get('api/PurchasePlanList/GetPurchasePlanList', {
					params: {
						id: id
					}
				}).then(function(result) {
					if (result.state != 1) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取订单信息失败:" + result.errorMsg
						});
						return
					}
					self.formatPurchaseList(result.data);
				}).catch(err => {})
			},
			formatPurchaseList(data) {
				this.documentItem.businessDate = formatDate(dateUtil.getCurrentDate(), 'yyyy-MM-dd')
				this.documentItem.purchaseDetailList = [];
				data.purchasePlanDetailList.forEach(item => {
					this.documentItem.purchaseDetailList.push({
						commodityId: item.commodity.id,
						name: item.commodity.name,
						unit: item.unit,
						format: item.format,
						quantity: item.quantity,
						depotId: 0,
						depotName: '',
						price: item.price,
						sellByDate: [],
						discount: 100,
						priceAfterDiscount: item.priceAfterDiscount,
						amount: item.amount,
						note: '',
						creator: parseInt(localStorage.getItem("userId")),
						commodity: item.commodity,
						commodityId: item.commodity.id
					});
				});
				this.documentItem.linkPlanListId = data.id
				this.documentItem.linkPlanListCode = data.code
				this.documentItem.linkPlanListDeposit = data.deposit //订单定金
				this.documentItem.supplierId = data.supplierId
				this.documentItem.supplierName = data.supplierName
				this.documentItem.supplierDiscount = data.supplierDiscount
				this.documentItem.userId = parseInt(localStorage.getItem("userId"))
				this.documentItem.userName = localStorage.getItem("userName")
				this.documentItem.creator = parseInt(localStorage.getItem("userId"));
				this.documentItem.internalInfo = '';
				this.documentItem.note = '';
				this.documentItem.payWay = '';
				this.documentItem.checkState = 1; //未过账
				this.documentItem.fileList = [];
			},
			initDepotData() {
				let self = this;
				request.get('/api/Depot/GetDepotList').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取仓库数据失败：" + response.errorMsg
						});
						return;
					}
					self.depotList = response.data;
				}).catch(function(error) {})
			},
			depotChange(val){
				for (let i = 0; i < this.documentItem.purchaseDetailList.length; i++) {
					this.documentItem.purchaseDetailList[i].depotId = this.documentItem.depotId;
				}
			}
		},
		watch: {
			'documentItem.purchaseDetailList': {
				deep: true,
				handler(arr) {
					this.countAmount();
				}
			},
			'documentItem.logisticsInfos': {
				deep: true,
				handler(arr) {
					this.countAmount();
				}
			},
			'documentItem.purchasePackageList': {
				deep: true,
				handler(arr) {
					this.countAmount();
				}
			},
			'documentItem.extraCostInfos': {
				deep: true,
				handler(arr) {
					this.extraAdvancePay = 0;
					this.extraSelfPay = 0;
					this.dfAdvancePay = 0;
					for (let i = 0; i < arr.length; i++) {
						if (arr[i].advancePayWay == "我方垫付") {
							this.extraAdvancePay += arr[i].amount;
						} else if (arr[i].advancePayWay == "对方垫付") {
							this.dfAdvancePay += arr[i].amount;
						} else if (arr[i].advancePayWay == "我方自付") {
							this.extraSelfPay += arr[i].amount;
						}
					}
					this.extraAdvancePay = formatNum(this.extraAdvancePay);
					this.extraSelfPay = formatNum(this.extraSelfPay);
					this.dfAdvancePay = formatNum(this.dfAdvancePay);
					this.countAmount();
				}
			},
			'$route.query.purchaseListId': {
				immediate: true,
				handler(param) {
					if (param) {
						this.getPurchaseList(param);
					} else {
						this.emptyForm();
					}
				}
			},
			'$route.query.linkPlanListId': {
				immediate: true,
				handler(param) {
					if (param) {
						this.initPurchasePlanList(param);
					} else {
						this.emptyForm();
					}
				}
			},
		},
		created: function() {
			this.emptyForm();
			this.initPermission();
			this.initUserToSelect();
			this.initSupplierSelect();
			this.initDepotData();
		}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}

	.tool-box {
		padding: 10px;
		background-color: #fff;
		overflow: hidden;
		border-left: 5px solid rgb(255, 106, 127);
		margin-bottom: 10px;
	}

	.tool-box Button {
		margin-left: 10px;
		float: right;
	}

	.tool-box-title {
		float: left;
		font-size: 16px;
		color: black;
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.baseInfo {
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.baseinfo-table {
		width: 100%;
		background-color: #fff;
		color: #666;
		border-collapse: collapse;
	}

	.baseinfo-table td,
	.baseinfo-table th {
		position: relative;
		padding: 9px 15px;
		min-height: 20px;
		line-height: 20px;
		font-size: 14px;
		border-width: 1px;
		border-style: solid;
		border-color: #e6e6e6;
	}


	.baseinfo-input {
		border: none;
		outline: none;
		height: 15px;
		padding-left: 0px;
		width: 100%;
	}

	.commodityInfo {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.file {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	#voucher-bottomBar {
		background-color: antiquewhite;
		padding: 7.5px 22px 0px 10px;
		box-shadow: 0 -1px 6pxrgba(0, 0, 0, .15);
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: auto !important;
		padding: 12px 30px !important;
	}

	.modal-title {
		overflow: hidden;
		padding-bottom: 10px;
		font-size: 16px;
	}

	.layout-title-left {
		float: left;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.layout-title-right {
		float: right;
	}

	.selectBox /deep/ div {
		border: none !important;
	}

	.discount-label {
		display: inline-block;
		text-align: center;
		width: 29%;
	}

	.billStateCls {
		width: 100px;
		height: 50px;
		line-height: 50px;
		font-size: 16px;
		position: absolute;
		top: 100px;
		left: 200px;
		border: solid 2px red;
		color: red;
		font-weight: 600;
		-webkit-transform: rotate(-30deg);
		transform: rotate(-30deg);
		z-index: 19999;
	}

	#extraCostInfo {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.logisticsInfo {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}
</style>